import { render, staticRenderFns } from "./BillingAddress.vue?vue&type=template&id=008310aa&"
import script from "./BillingAddress.vue?vue&type=script&lang=js&"
export * from "./BillingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports